import React, { Component } from "react";
import { connect } from "react-redux";
import { reduxForm, formValueSelector } from "redux-form";
import { Form, Modal, FormGroup } from "react-bootstrap";
import _ from "lodash";

import Button from "../../../../../components/common/button/Button";
import styles from "./Filters.scss";
import AddFilterBox from "./AddFilterBox";

import {
  getCategories,
  fetchSkills
} from "../../../../../actions/skills.actions";
import {
  fetchIndustries,
  getCommuteCities,
  getLevels
} from "../../../../../actions/dropdowns.actions";

import { getFilterFromRouteState } from "../../../../../utils/parseQueries";

class Filters extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: props.show || false
    };

    this.handleClose = this.handleClose.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
  }

  componentDidMount() {
    this.props.fetchSkills();
    this.props.getCategories();
    this.props.getCommuteCities();
    this.props.getLevels();
    this.props.getIndustries();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.show !== nextProps.show) {
      this.setState({ show: nextProps.show });
    }
  }

  handleClose() {
    this.setState({ show: false }, this.props.onClose);
  }

  applyFilters() {
    this.handleClose();
  }

  render() {
    const { submitting, valid } = this.props;

    return (
      <Modal
        show={this.state.show}
        onHide={this.handleClose}
        dialogClassName={styles.modalContainer}
      >
        <Modal.Body className={styles.modalBody}>
          <Form onSubmit={this.props.handleSubmit}>
            <FormGroup>
              <div className={styles.title}>Filter Potential Matches Table</div>
              <div className={styles.dividerDouble} />
              <div className={styles.subtitle}>
                Find just what you’re looking for by creating filters for your
                current data set.
              </div>
              <div className={styles.filtersContainer}>
                <AddFilterBox
                  name="filters"
                  addText="Add Filter"
                  skillsCategoriesOptions={this.props.categories}
                  skillsOptions={this.props.skills}
                  selectedSkillCategory={this.props.skillCategory}
                  commuteCitiesOptions={this.props.commuteCities}
                  levelsOptions={this.props.levels}
                  industriesOptions={this.props.industries}
                />
              </div>
            </FormGroup>

            <div className={styles.dividerDouble} />

            <div className={styles.CTAContainer}>
              <Button
                isPrimary
                type="submit"
                label="View Results"
                onClick={this.applyFilters}
                isDisabled={!valid || submitting}
              />
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    );
  }
}

Filters = reduxForm({
  form: "potentialMatchesTableFilters",
  enableReinitialize: true,
  destroyOnUnmount: true
})(Filters);

const selector = formValueSelector("potentialMatchesTableFilters");
const getChild = _.property("skill_category");
Filters = connect(
  state => {
    let skillCategory;
    const skillCategorySelector = selector(state, "filters");
    if (skillCategorySelector) {
      skillCategory = skillCategorySelector
        .map(getChild)
        .filter(e => e === 0 || e);
    }

    return {
      skillCategory,
      categories: state.skills.categories.data,
      skills: state.skills.skills.data,
      commuteCities: state.dropdowns.commuteCities.data,
      levels: state.dropdowns.levels.data,
      industries: state.dropdowns.industries.data,
      initialValues: getFilterFromRouteState(state, "filters")
    };
  },
  dispatch => {
    return {
      getCategories: () => dispatch(getCategories()),
      fetchSkills: () => dispatch(fetchSkills()),
      getCommuteCities: () => dispatch(getCommuteCities()),
      getLevels: () => dispatch(getLevels()),
      getIndustries: () => dispatch(fetchIndustries())
    };
  }
)(Filters);

export default Filters;



// WEBPACK FOOTER //
// ./src/routes/admin/project/potentialMatches/components/Filters.js